import './videoBackground.scss';
import { useIntersectionObserver } from '@rocketmakers/armstrong';
import * as React from 'react';
export const VideoBackground = ({ videoUrl, videoPosterUrl, className, children }) => {
    const [inView, setInView] = React.useState(false);
    const onIntersect = (isIntersecting, entries, io) => {
        if (isIntersecting) {
            entries[0].target.querySelector('video').play();
            io.disconnect();
            setInView(true);
        }
    };
    const ref = React.useRef(null);
    useIntersectionObserver(ref, onIntersect, { rootMargin: '100px' });
    return (<div className={`video-background-wrapper ${className ? ` ${className}` : ''}`} ref={ref} data-in-view={inView}>
      <div className="video-background-spacer"/>
      <video className="video-background" loop={true} preload="none" muted={true} poster={videoPosterUrl}>
        <source src={videoUrl} type="video/mp4"/>
      </video>
      {children && <div className="video-background-content">{children}</div>}
    </div>);
};
